import Vue from "vue";
import VueMq from "vue-mq";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import NsAppService from "./services/NsAppService";

import { NsAnimateHeight } from "@nuskin/design-components";

import NsDonationForm from "./components/NsDonationForm.vue";
import NsDonationReceipt from "./components/NsDonationReceipt.vue";
import NsDynamicHtml from "./components/NsDynamicHtml.vue";
import NsFeature from "./components/NsFeature.vue";
import NsFooter from "./components/NsFooter.vue";
import NsFooterNav from "./components/NsFooterNav.vue";
import NsHeader from "./components/NsHeader.vue";
import NsHeaderLegalLinks from "./components/NsHeaderLegalLinks.vue";
import NsHeaderLoyaltyRewards from "./components/NsHeaderLoyaltyRewards.vue";
import NsHeaderMarketingMessage from "./components/NsHeaderMarketingMessage.vue";
import NsHeaderProfile from "./components/NsHeaderProfile.vue";
import NsHeaderRegionSelector from "./components/NsHeaderRegionSelector.vue";
import NsHero from "./components/NsHero.vue";
import NsInformationButton from "./components/NsInformationButton.vue";
import NsInformationCard from "./components/NsInformationCard.vue";
import NsLogo from "./components/NsLogo.vue";
import NsMiniCart from "./components/NsMiniCart.vue";
import NsMinimalHeader from "./components/NsMinimalHeader.vue";
import NsSearchbar from "./components/NsSearchbar.vue";
import NsSearchbarButton from "./components/NsSearchbarButton.vue";
import NsSearchbarInput from "./components/NsSearchbarInput.vue";
import NsSearchbarList from "./components/NsSearchbarList.vue";
import NsSearchbarTooltip from "./components/NsSearchbarTooltip.vue";
import NsSectionHeader from "./components/NsSectionHeader.vue";
import NsSocialIcons from "./components/NsSocialIcons.vue";
import NsStripeDonationForm from "./components/NsStripeDonationForm.vue";
import NsTopnav from "./components/NsTopnav.vue";
import NsTopnavGivingBack from "./components/NsTopnavGivingBack.vue";
import NsTopnavImageOverlay from "./components/NsTopnavImageOverlay.vue";
import NsTopnavLinkList from "./components/NsTopnavLinkList.vue";
import NsTopnavNavigation from "./components/NsTopnavNavigation.vue";
import NsTopnavProductHighlight from "./components/NsTopnavProductHighlight.vue";
import NsTopnavProductLine from "./components/NsTopnavProductLine.vue";
import NsTopnavSection from "./components/NsTopnavSection.vue";

window.Vue = Vue;
Vue.config.silent = true;

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export {
  // Services
  NsAppService,
  // Components
  NsAnimateHeight,
  NsDonationForm,
  NsDonationReceipt,
  NsDynamicHtml,
  NsFooter,
  NsFooterNav,
  NsHeader,
  NsHeaderLegalLinks,
  NsHeaderLoyaltyRewards,
  NsHeaderMarketingMessage,
  NsHeaderProfile,
  NsHeaderRegionSelector,
  NsHero,
  NsInformationButton,
  NsInformationCard,
  NsLogo,
  NsMiniCart,
  NsMinimalHeader,
  NsSearchbar,
  NsSearchbarButton,
  NsSearchbarInput,
  NsSearchbarList,
  NsSearchbarTooltip,
  NsSectionHeader,
  NsSocialIcons,
  NsStripeDonationForm,
  NsTopnav,
  NsTopnavGivingBack,
  NsTopnavImageOverlay,
  NsTopnavLinkList,
  NsTopnavNavigation,
  NsTopnavProductHighlight,
  NsTopnavProductLine,
  NsTopnavSection,
  NsFeature
};
